import { DEFAULT_DIALOG_CONFIG, DialogConfig } from '@angular/cdk/dialog';
import { Provider } from '@angular/core';

/**
 * Every CDK dialog in the app declares `aria-modal="true"` (AT-2446).
 *
 * The design system's `ModalService` opens through CDK `Dialog` with its own defaults spread over the
 * caller's config, and neither sets `ariaModal`, so CDK's own default (`false`) used to reach the
 * container. CDK spreads THIS object under every config, in place of `new DialogConfig()`, which is
 * why it has to be a `DialogConfig` instance: a plain `{ ariaModal: true }` would drop `role`,
 * `autoFocus`, `restoreFocus`, `closeOnDestroy` and the rest of the class's defaults.
 *
 * Nothing else is needed for the background: CDK already marks the overlay container's siblings
 * `aria-hidden` while a dialog is open and traps focus in the container.
 */
export const provideDialogDefaults = (): Provider => ({
  provide: DEFAULT_DIALOG_CONFIG,
  useValue: Object.assign(new DialogConfig(), { ariaModal: true }),
});
